import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';
import { booking, leg, product, passenger } from '../queries/GET_BOOKING';

export default gql`
  mutation cancelBookingItems(
    $bookingReference: String!
    $overrideReason: String
    $overrideAftersalesRules: Boolean
  ) {
    cancelBookingItems(
      bookingReference: $bookingReference
      overrideReason: $overrideReason
      overrideAftersalesRules: $overrideAftersalesRules
    ) {
      ${booking}
    }
  }

  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
